import React from 'react';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Colors } from 'library';
import { Card, ExpandableCard, Grid, Icon, Row, Stack, Text, Title } from 'library/ui';

import type { SubPoolSummary, SubPoolInfoCard } from '../types';
import { getElcIcon } from './elcIcons';

function InfoCardContent({ card }: { card: SubPoolInfoCard }) {
    const CardIcon = getElcIcon(card.icon);
    return (
        <Stack gap="sm">
            {CardIcon && <Icon icon={CardIcon} iconColor={Colors.white} bgColor={Colors.secondary} />}
            <Text weight="bold">
                {card.title}
                {card.link && <OpenInNewIcon style={{ fontSize: 14, marginLeft: 4, verticalAlign: 'middle' }} />}
            </Text>
            <Text size="sm" tone="secondary">
                {card.description}
            </Text>
        </Stack>
    );
}

export function ELCResourceCard({ partner }: { partner: SubPoolSummary }) {
    const logoWidth = partner.logo_width_card ?? 56;
    return (
        <ExpandableCard
            header={
                <Row gap="md" align="center">
                    <img
                        src={partner.logo_url || ''}
                        alt={partner.full_name ?? partner.name}
                        style={{ width: logoWidth, height: logoWidth, objectFit: 'contain' }}
                    />
                    <Stack gap="none">
                        <Title size="h2" tone="accent">{`${partner.name}'s Substitute Pool`}</Title>
                        <Text size="sm" tone="secondary">
                            Powered by Tandem — Resources &amp; Info
                        </Text>
                    </Stack>
                </Row>
            }
        >
            <Stack gap="md">
                <Text size="sm" tone="secondary">
                    {partner.description}
                </Text>
                <Grid minColumnWidth={200} gap="md">
                    {partner.info_cards.map((card) =>
                        card.link ? (
                            <Card key={card.title} href={card.link} padding="md" fullHeight tone="muted">
                                <InfoCardContent card={card} />
                            </Card>
                        ) : (
                            <Card key={card.title} padding="md" fullHeight tone="muted">
                                <InfoCardContent card={card} />
                            </Card>
                        ),
                    )}
                </Grid>
                {partner.website_url && (
                    <Card href={partner.website_url} padding="md" tone="muted">
                        <Row gap="md">
                            <Icon icon={OpenInNewIcon} iconColor={Colors.white} bgColor={Colors.secondary} />
                            <Stack gap="none">
                                <Text weight="bold">
                                    {`${partner.name} Website`}{' '}
                                    <OpenInNewIcon style={{ fontSize: 14, verticalAlign: 'middle' }} />
                                </Text>
                                <Text size="sm" tone="secondary">
                                    {`Explore resources, programs, and support from the ${partner.name}.`}
                                </Text>
                            </Stack>
                        </Row>
                    </Card>
                )}
            </Stack>
        </ExpandableCard>
    );
}
